if ( typeof SimpleMenu !== 'function' ) {

  class SimpleMenu extends HTMLElement {

    constructor() {

      super();

      this.items = this.querySelectorAll('.simple-menu__item--has-dropdown, .simple-menu__dropdown-item--has-nested');

      this.items.forEach(item => {
        const link = item.querySelector('a');
        const dropdown = item.querySelector('.simple-menu__dropdown, .simple-menu__nested');

        // Mouse events (desktop only)
        item.addEventListener('mouseenter', () => {
          if (window.innerWidth > 1023) {
            item.classList.add('focused');
            if (link) {
              link.setAttribute('aria-expanded', 'true');
            }
          }
        });

        item.addEventListener('mouseleave', () => {
          if (window.innerWidth > 1023) {
            item.classList.remove('focused');
            if (link) {
              link.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // Touch events (mobile)
        link.addEventListener('click', (e) => {
          if (window.innerWidth <= 1023 && dropdown) {
            e.preventDefault();
            const isFocused = item.classList.contains('focused');
            
            // Close all other dropdowns
            this.items.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('focused');
                const otherLink = otherItem.querySelector('a');
                if (otherLink) {
                  otherLink.setAttribute('aria-expanded', 'false');
                }
              }
            });
            
            // Toggle current dropdown
            if (isFocused) {
              item.classList.remove('focused');
              link.setAttribute('aria-expanded', 'false');
            } else {
              item.classList.add('focused');
              link.setAttribute('aria-expanded', 'true');
            }
          }
        });

        // Keyboard navigation
        link.addEventListener('keydown', (e) => {
          if (e.keyCode === 40 || e.keyCode === 38) { // Arrow down or up
            e.preventDefault();
            if (!item.classList.contains('focused')) {
              item.classList.add('focused');
              link.setAttribute('aria-expanded', 'true');
              const firstLink = dropdown?.querySelector('a');
              if (firstLink) {
                firstLink.focus();
              }
            }
          } else if (e.keyCode === 27) { // Escape
            item.classList.remove('focused');
            link.setAttribute('aria-expanded', 'false');
            link.focus();
          }
        });

        // Focus management for nested menus
        if (dropdown) {
          const nestedLinks = dropdown.querySelectorAll('a');
          const lastLink = nestedLinks[nestedLinks.length - 1];

          lastLink?.addEventListener('keydown', (e) => {
            if (e.keyCode === 9 && !e.shiftKey) { // Tab forward
              item.classList.remove('focused');
            }
          });

          nestedLinks[0]?.addEventListener('keydown', (e) => {
            if (e.keyCode === 9 && e.shiftKey) { // Shift+Tab backward
              item.classList.remove('focused');
              link.setAttribute('aria-expanded', 'false');
              link.focus();
            }
          });
        }
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.items.forEach(item => {
            item.classList.remove('focused');
            const link = item.querySelector('a');
            if (link) {
              link.setAttribute('aria-expanded', 'false');
            }
          });
        }
      });

    }

  }

  if ( typeof customElements.get('simple-menu') == 'undefined' ) {
    customElements.define('simple-menu', SimpleMenu);
  }

}

// Mobile simple menu handler
if ( typeof MobileSimpleMenu !== 'function' ) {

  class MobileSimpleMenu extends HTMLElement {

    constructor() {

      super();

      this.items = this.querySelectorAll('.mobile-simple-menu__item--has-dropdown, .mobile-simple-menu__dropdown-item--has-nested');

      this.items.forEach(item => {
        const link = item.querySelector('a');
        const dropdown = item.querySelector('.mobile-simple-menu__dropdown, .mobile-simple-menu__nested');

        // Touch events for mobile
        link.addEventListener('click', (e) => {
          if (dropdown) {
            e.preventDefault();
            const isFocused = item.classList.contains('focused');
            
            // Close all other dropdowns
            this.items.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('focused');
                const otherLink = otherItem.querySelector('a');
                if (otherLink) {
                  otherLink.setAttribute('aria-expanded', 'false');
                }
              }
            });
            
            // Toggle current dropdown
            if (isFocused) {
              item.classList.remove('focused');
              link.setAttribute('aria-expanded', 'false');
            } else {
              item.classList.add('focused');
              link.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });

    }

  }

  if ( typeof customElements.get('mobile-simple-menu') == 'undefined' ) {
    customElements.define('mobile-simple-menu', MobileSimpleMenu);
  }

}

